import React from 'react';

import enhanceWithClickOutside from 'react-click-outside';

class DropdownSearch extends React.Component {
    constructor(props) {
        super(props);
        /* STATES
         * show: show dropdown when typed or not clicking outside
         *
         */
        this.state = {
            clickedOutside: false,
            show: false,
            typed: false,
            clicked: false
        }
    }

    handleClickOutside (e) {
        console.log("clicked outside")
        this.setState({
            clickedOutside: true,
            typed: false,
            show: false,
            clicked: this.props.clicked
        })
        this.props.clearTypeStatus();
        // if (this.props.clicked) {
        //     this.props.clearClickStatus()
        // }
    }
    // whenever, it's typed, change clickedOutside to false
    static getDerivedStateFromProps(nextProps, prevState) {
        // console.log("before", nextProps, prevState)
        if ((nextProps.typed)) {
            return {
                clicked: nextProps.clicked,
                show: true,
                typed: nextProps.typed,
                clickedOutside: false
            }
        } else {
            return {
                show: false
            }
        }
    }
    render () {
        // console.log("after", this.props, this.state)
        return (
            <div className={this.state.show ? "dropdown-search dropdown-menu show" : "dropdown-search dropdown-menu"}>
                <h6 className="dropdown-header">Rentals</h6>
                <a className="dropdown-item" href="#">Action</a>
                <a className="dropdown-item" href="#">Another action</a>
                <div className="dropdown-divider"></div>
                <h6 className="dropdown-header">Users</h6>
                <a className="dropdown-item" href="#">Action</a>
                <a className="dropdown-item" href="#">Another action</a>
            </div>
        )
    }
}

export default enhanceWithClickOutside(DropdownSearch);